export default {
  "APP_COMMERCE_VIEW": "APP_COMMERCE_VIEW",
  "APP_PRODUCT_IDENTIFIER_UPDATE":"APP_PRODUCT_IDENTIFIER_UPDATE",
  "STOCK_MOVE_APP_VIEW": "STOCK_MOVE_APP_VIEW",
} as any